<template>
  <b-sidebar
    v-if="isSidebarDetailActive"
    :visible="isSidebarDetailActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm()"
    @change="updateIsSidebarActive($event)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Customer Contact Detail
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide" />
      </div>
      <!-- BODY -->
      <ValidationObserver
        #default="{ handleSubmit }"
        ref="CustomerContactDetailForm">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm()">
          <!-- <TextFieldInput
            v-model="customerContact.code"
            name="Code"
            label="Code"
            trim /> -->
          <TextFieldInput
            v-model="customerContact.firstName"
            name="First Name"
            label="First Name"
            :rules="{ required: true }"
            trim />
          <TextFieldInput
            v-model="customerContact.lastName"
            name="Last Name"
            label="Last Name"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.contactPhoneNo"
            name="Contact PhoneNo"
            label="Contact PhoneNo"
            :rules="{ required: false }"
            trim
          />
          <TextFieldInput
            v-model="customerContact.contactPhoneNo2"
            name="Contact PhoneNo 2"
            label="Contact PhoneNo 2"
            :rules="{ required: false }"
            trim
          />
          <TextFieldInput
            v-model="customerContact.contactEmail"
            name="Contact Email"
            label="Contact Email"
            :rules="{ required: false, email: true }"
            trim />
          <TextFieldInput
            v-model="customerContact.contactLine"
            name="Contact Line"
            label="Contact Line"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.contactFacebook"
            name="Contact Facebook"
            label="Contact Facebook"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.detail"
            name="Detail"
            label="Detail"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.note1"
            name="Note1"
            label="Note1"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.note2"
            name="Note2"
            label="Note2"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.note3"
            name="Note3"
            label="Note3"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.note4"
            name="Note4"
            label="Note4"
            :rules="{ required: false }"
            trim />
          <TextFieldInput
            v-model="customerContact.note5"
            name="Note5"
            label="Note5"
            :rules="{ required: false }"
            trim />
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 btn-submit"
              type="submit"
              :disabled="compareOldValue">
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              class="btn-submit"
              variant="outline-secondary"
              @click="resetForm()">
              Cancel
            </b-button>
            <b-button
              variant="outline-danger"
              class="btn-icon ml-auto"
              :disabled="!compareOldValue"
              @click="deleteItem ()">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </template>
  </b-sidebar>
</template>

<script>
import TextFieldInput from '@/components/Form/TextFieldInput.vue'

export default {
  components: { TextFieldInput },
  model: {
    prop: 'isSidebarDetailActive',
    event: 'update:is-sidebar-detail-active'
  },
  props: {
    isSidebarDetailActive: {
      type: Boolean,
      default: false
    },
    initialCustomerContact: {
      type: Object,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    customerContact: {
      get () {
        return this.selectedItem
      },
      set (val) {
        this.$emit('update:selected-item', val)
      }
    },
    compareOldValue () {
      return JSON.stringify(this.customerContact) === JSON.stringify(this.initialCustomerContact)
    }
  },
  methods: {
    updateIsSidebarActive (val) {
      this.$emit('update:is-sidebar-detail-active', val)
    },
    onSubmit () {
      const payload = {
        id: this.customerContact.id,
        firstName: this.customerContact.firstName,
        lastName: this.customerContact.lastName,
        contactPhoneNo: this.$replacePhoneNumber(this.customerContact.contactPhoneNo, '+66'),
        contactPhoneNo2: this.$replacePhoneNumber(this.customerContact.contactPhoneNo2, '+66'),
        contactEmail: this.customerContact.contactEmail,
        contactLine: this.customerContact.contactLine,
        contactFacebook: this.customerContact.contactFacebook,
        detail: this.customerContact.detail,
        note1: this.customerContact.detail,
        note2: this.customerContact.note2,
        note3: this.customerContact.note3,
        note4: this.customerContact.note4,
        note5: this.customerContact.note5
      }
      this.$emit('update-company-contact', payload)
    },
    resetForm () {
      this.updateIsSidebarActive()
      this.customerContact = { ...this.initialCustomerContact }
      this.$refs.CustomerContactDetailForm.reset()
    },
    deleteItem () {
      this.$emit('delete-item', this.customerContact)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-submit {
  min-width: 134px;
}
</style>
